/* PS Recipe Lead Capture — scroll reveal + recipe unlock on success */
(function () {
  if (window.__PS_RECIPE_LEADCAP__) return;
  window.__PS_RECIPE_LEADCAP__ = true;

  function revealSection(section) {
    var els = section.querySelectorAll('.reveal:not(.in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('in');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  function unlockRecipeCard(section) {
    var card = section.querySelector('.leadcap-recipe-card');
    if (!card || card.classList.contains('is-unlocked')) return;
    card.classList.add('is-unlocked');
    card.setAttribute('data-locked', 'false');
  }

  function observeRecipeUnlock(section) {
    var success = section.querySelector('.leadcap-success');
    var card = section.querySelector('.leadcap-recipe-card');
    if (!success || !card) return;

    function maybeUnlock() {
      if (!success.hasAttribute('hidden')) unlockRecipeCard(section);
    }

    maybeUnlock();

    if (!('MutationObserver' in window)) return;
    var mo = new MutationObserver(function () { maybeUnlock(); });
    mo.observe(success, { attributes: true, attributeFilter: ['hidden'] });
  }

  function initSection(section) {
    revealSection(section);
    observeRecipeUnlock(section);
  }

  function init() {
    document.querySelectorAll('.ps-recipe-leadcap').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
